import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'

let { Session } = utils_tool;
let { WizContainer } = framework_tool
let {
  WizCustomSteps,
  WizForm,
  WizRow,
  WizCol,
  WizSpin,
  WizButton
} = component_tool
import { modelUtils } from '@/utils'
import columns from './columns'
import './index.less'

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/examTemplateGroup/examTemplateGroupDetailUpd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateGroupDetailInfo', record)
      } else {
        record = Session.get('examTemplateGroupDetailInfo') || {}
      }
    }
    // if (history.location.pathname === '/online/examTemplateGroup/examTemplateGroupDetailAdd') {
    //   if (history.location && history.location.record) {
    //     record = history.location.record
    //     Session.set('examTemplateGroupDetailInfo', record)
    //   } else {
    //     record = Session.get('examTemplateGroupDetailInfo') || {}
    //   }
    // }
  }
  return record
}


class ExamTemplateGroupDetail extends WizContainer {
  componentName = 'examTemplateGroupDetail'

  constructor(props) {
    super(props)
    let record = getParamRecord(props.history)
    this.state = {
      record, pathUrl: '',
      formKey: 'formKey',
      // categoryTypeIds: record.categoryTypeId ? [record.categoryTypeId] : ['0'] //没有选择不能搜索出数据
      categoryTypeIds: record.categoryTypeId ? [record.categoryTypeId] : null
    }
    this._examTemplateGroupId = record.id
  }

  _componentDidMount() {
    if (this._examTemplateGroupId) {
      this.doActions([
        {
          path: "examTemplateGroup/getExamTemplateGroupById",
          payload: {
            key: "groupInfo",
            apiParams: {
              id: this._examTemplateGroupId,
            },
          },
        },
      ]);
    }
  }

  _renderFooter = () => {
    return (
      <WizRow className='form-btns col-item'>
        <WizCol span={24}>
          <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
            onClick={e => this._onSave(e)}>保存并进入下一步</WizButton>
          <WizButton title='重置' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  _render() {
    const { record, categoryTypeIds } = this.state
    let { categoryType, categoryTypeId } = record;
    let selects =
      categoryType && categoryTypeId
        ? [{ label: categoryType, title: categoryType, key: categoryTypeId }]
        : [];
    let formProps = {
      key: this.state.key,
      ref: 'form',
      record: this._examTemplateGroupId ? this.state.record : { status: 1 },
      columns: columns(this, {
        selects,
        categoryTypeIds: categoryTypeIds,
        isUpdate: this._examTemplateGroupId?true:false
      }),
      footer: this._renderFooter(),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      }
    }
    let wizCustomStepsProps = {
      header: [
        { title: '模版组信息' },
        { title: '受众设置' }
      ],
      current: 0,
      content: <WizSpin tip={'加载中'} spinning={this.props.examTemplateGroupLoading}><WizForm key={this.state.formKey} {...formProps} /></WizSpin>
    }
    return <WizCustomSteps key={this.state.formKey} {...wizCustomStepsProps} />
  }

  propsAndStateOnChange = {
    createExamTemplateGroup: this._createExamTemplateGroupOnChange.bind(this),
    updateExamTemplateGroup: this._updateExamTemplateGroupOnChange.bind(this),
    groupInfo: this._getInfoOver.bind(this)
  }

  _onSave = (e) => {
    let form = this.refs.form
    if (form) {
      form.validateFields((err, values) => {
        if (err) return;
        if (this._examTemplateGroupId) {
          values.pathUrl = 'examTemplateGroup/update'
          this.doAction({
            path: 'examTemplateGroup/update',
            payload: {
              key: 'examTemplateGroup@update',
              apiParams: { id: this._examTemplateGroupId, ...values }
            }
          })
        } else {
          values.pathUrl = 'examTemplateGroup/add'
          this.doAction({
            path: 'examTemplateGroup/add',
            payload: {
              key: 'examTemplateGroup@create',
              apiParams: { ...values }
            }
          })
        }
        this.state.pathUrl = values.pathUrl
      })
    }
  }

  _onReset() {
    this.setState({ key: 'examTemplateGroupDetail_' + new Date().getTime() })
  }

  _createExamTemplateGroupOnChange(nextProps, nextState) {
    if (nextProps.createExamTemplateGroup.code === 1) {
      this._examTemplateGroupId = nextProps.createExamTemplateGroup.data
      this._nextPage()
    } else {
      wizNotice.error(nextProps.createExamTemplateGroup.msg)
    }
    return true
  }

  _updateExamTemplateGroupOnChange(nextProps, nextState) {
    if (nextProps.updateExamTemplateGroup.code === 1) {
      this._nextPage()
    } else {
      wizNotice.error(nextProps.createExamTemplateGroup.msg)
    }
    return true
  }

  _getInfoOver(nextProps, nextState) {
    if (nextProps.groupInfo.code === 1) {
      nextState.record = nextProps.groupInfo.data;
      nextState.formKey = 'formKey'+nextProps.groupInfo.data.id;
      return true;
    }
    return false
  }

  _nextPage() {
    if (this._examTemplateGroupId && this._examTemplateGroupId['id']) {
      this._examTemplateGroupId = this._examTemplateGroupId['id']
    }
    this.jumpPage(
      'push',
      '/online/examTemplateGroup/examTemplateAuth',
      {
        id: this._examTemplateGroupId,
        header: [
          { title: '模版组信息' },
          { title: '受众设置' }
        ],
        current: 1,
        savePath: 'examTemplateGroup',
        nextFunc: '/online/examTemplateGroup',
        pathUrl: this.state.pathUrl
      }
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { examTemplateGroup } = state
  const createExamTemplateGroup = modelUtils.getModelEntity(examTemplateGroup, 'examTemplateGroup@create')
  const updateExamTemplateGroup = modelUtils.getModelEntity(examTemplateGroup, 'examTemplateGroup@update')
  const groupInfo = modelUtils.getModelEntity(examTemplateGroup, 'groupInfo')
  const load = modelUtils.getLoadingState(state, 'examTemplateGroup')
  return {
    createExamTemplateGroup,
    updateExamTemplateGroup,
    groupInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ExamTemplateGroupDetail)
